
import React, { useEffect, useState, useRef } from "react";
import "./DocumentManager.css";
import ImportDocument from './ImportDocument';
import Slider from "react-slick";
import DocumentVault from "./DocumentVault";
import { useLocation, useNavigate } from "react-router-dom";
import HttpClient from "../../utils/HttpClient";
import { useLanguage } from "../../Providers/LanguageContext";

function Index() {
    const location = useLocation();
    const { language } = useLanguage();
    const navigate = useNavigate();

    // Create a reference for the Slider component
    const sliderRef = useRef(null);

    // State to track the current slide index
    const [currentSlide, setCurrentSlide] = useState(location.state?.slideNo || 0);

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe:false,
        initialSlide: location.state?.slideNo || 0,
        afterChange: (current) => setCurrentSlide(current) // Update current slide index
    };

    const [docData, setDocData] = useState([]);

    const getAllDocument = async () => {
        const res = await HttpClient.requestData("view/count/selfservice-document", "GET", {});
        if (res && res?.status) {
            setDocData(res?.data);
        }
    };

    useEffect(() => {
        getAllDocument();
    }, []);
    useEffect(() => {
        window.scrollTo({ top: '0', behavior: 'instant' })
    }, [])
    // Handle slide change
    const goToSlide = (slideIndex) => {
        if (sliderRef.current) {
            sliderRef.current.slickGoTo(slideIndex);
        }
    };

    return (
        <>
            {/* <div className="try_fisibilty_wrapper " style={{
                transform: 'translateY(0%)',
                margin: '0px',
                justifyContent: 'start',
                background: '#031f31ff'

            }}>
                <div className="container-fluid">
                    <p className="text-left">Document Manager / Import View Documents</p></div>
            </div> */}


            <div className="DocumentManager_mainwrap" style={{
                background: 'linear-gradient(rgba(15, 36, 55, 1), rgb(255, 255, 255))',

            }}>
                <div className='w-100 container-fluid navigation_buttons_wrapper gap-3 ' style={{
                    display:'flex',
                    columnGap:'10px'
                }}>
                    <button
                        className={`slctUser ${currentSlide === 0 ? 'btn-success' : 'btn-outline-success'}`}
                        style={{
                            background: 'rgb(136, 233, 132)',
                            fontWeight: '500',
                            color: '#0c2637'
                        }}

                        onClick={() => goToSlide(0)}
                        disabled={currentSlide === 0} // Disable button if already on slide 0
                    >
                        {language.imp_docs}
                    </button>
                    <button
                        className={`slctUser ${currentSlide === 1 ? 'btn-success' : 'btn-outline-success'}`}
                        style={{
                            background: 'rgb(136, 233, 132)',
                            fontWeight: '500',
                            color: '#0c2637'
                        }}

                        onClick={() => goToSlide(1)}
                        disabled={currentSlide === 1} // Disable button if already on slide 1
                    >
                        {language.view_docs_vault}
                    </button>
                </div>
                <Slider ref={sliderRef} {...settings}>
                    <div>
                        <ImportDocument getAllDocument={getAllDocument} />
                    </div>
                    <div>
                        <DocumentVault docData={docData} />
                    </div>
                </Slider>
            </div>
        </>
    );
}

export default Index;

